/**
 * Header JS — Scroll detection, mega menu management, mini cart popover, mobile nav
 * Extracted from inline scripts in sections/header.liquid
 */
(function() {
  var header = document.querySelector('header[data-section-id]');
  if (!header) return;

  var sectionId = header.getAttribute('data-section-id');
  var section = document.getElementById('shopify-section-' + sectionId);
  if (!section) return;

  /* ==================================================
     SCROLL DETECTION + MEGA MENU CLOSE ON SCROLL
     ================================================== */
  var lastY = window.scrollY;
  var ticking = false;
  var announcementBar = document.querySelector('[data-announcement-bar]');

  function updateAnnouncementOffset(y) {
    if (!announcementBar) return;
    var barHeight = announcementBar.offsetHeight;
    var offset = Math.max(0, barHeight - y);
    document.documentElement.style.setProperty('--announcement-offset', offset + 'px');
  }

  function update() {
    var y = window.scrollY;
    updateAnnouncementOffset(y);
    if (y > 50) {
      section.classList.add('is-scrolled');
      section.classList.toggle('scrolling-down', y > lastY);
      section.classList.toggle('scrolling-up', y <= lastY);
    } else {
      section.classList.remove('is-scrolled', 'scrolling-down', 'scrolling-up');
    }
    if (Math.abs(y - lastY) > 5) {
      section.querySelectorAll('details[open]').forEach(function(d) {
        d.removeAttribute('open');
      });
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();

  /* --header-height via ResizeObserver */
  if (window.ResizeObserver) {
    new ResizeObserver(function(entries) {
      var h = entries[0].borderBoxSize
        ? entries[0].borderBoxSize[0].blockSize
        : entries[0].target.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }).observe(section);
  }

  /* Close sibling <details> when one opens */
  section.addEventListener('toggle', function(e) {
    if (e.target.tagName === 'DETAILS' && e.target.open) {
      section.querySelectorAll('details[open]').forEach(function(d) {
        if (d !== e.target) d.removeAttribute('open');
      });
    }
  }, true);

  /* Track open <details> to avoid querying the DOM on every click/keydown */
  var openDetailsCount = 0;
  section.addEventListener('toggle', function(e) {
    if (e.target.tagName !== 'DETAILS') return;
    openDetailsCount = section.querySelectorAll('details[open]').length;
  }, true);

  /* Outside click closes all <details> */
  document.addEventListener('click', function(e) {
    if (openDetailsCount === 0) return;
    if (!e.target.closest('.header__pill')) {
      section.querySelectorAll('details[open]').forEach(function(d) {
        d.removeAttribute('open');
      });
    }
  });

  /* Escape closes all <details> */
  document.addEventListener('keydown', function(e) {
    if (openDetailsCount === 0 || e.key !== 'Escape') return;
    section.querySelectorAll('details[open]').forEach(function(d) {
      d.removeAttribute('open');
    });
  });

  /* ==================================================
     MINI CART POPOVER
     ================================================== */
  var miniCart = section.querySelector('.header__mini-cart');
  if (miniCart) {
    var itemsContainer = miniCart.querySelector('.header__mini-cart-items');
    var emptyState = miniCart.querySelector('.header__mini-cart-empty');
    var badge = miniCart.querySelector('.header__cart-count');
    var footer = miniCart.querySelector('.header__mini-cart-footer');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' €';
    }

    function renderCart(cart) {
      if (badge) {
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }

      if (cart.item_count === 0) {
        itemsContainer.style.display = 'none';
        emptyState.style.display = '';
        footer.style.display = 'none';
        return;
      }

      emptyState.style.display = 'none';
      itemsContainer.style.display = '';
      footer.style.display = '';

      itemsContainer.innerHTML = cart.items.map(function(item) {
        var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_100x100$1') : '';
        var variantLine = item.variant_title || '';
        var url = item.url || '#';
        return '<div class="header__mini-cart-item">' +
          (imgSrc ? '<a class="header__mini-cart-item-img-link" href="' + url + '"><img class="header__mini-cart-item-img" src="' + imgSrc + '" alt="" loading="lazy" width="40" height="40"></a>' : '') +
          '<div class="header__mini-cart-item-info">' +
            '<a class="header__mini-cart-item-title" href="' + url + '">' + item.product_title + '</a>' +
            (variantLine ? '<span class="header__mini-cart-item-variant">' + variantLine + '</span>' : '') +
          '</div>' +
        '</div>';
      }).join('');
    }

    function fetchAndRender() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function() {});
    }

    miniCart.addEventListener('toggle', function() {
      if (miniCart.open) fetchAndRender();
    });

    document.addEventListener('cart:change', fetchAndRender);

    /* Initial fetch deferred to idle — badge is server-rendered, no rush */
    function deferredInitialFetch() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fetchAndRender, { timeout: 3000 });
      } else {
        setTimeout(fetchAndRender, 1500);
      }
    }
    if (document.readyState === 'complete') {
      deferredInitialFetch();
    } else {
      window.addEventListener('load', deferredInitialFetch, { once: true });
    }
  }

  /* ==================================================
     MOBILE NAVIGATION OVERLAY
     ================================================== */
  var overlay = document.getElementById('header-sidebar-menu');
  if (!overlay) return;

  var toggleBtn = document.querySelector('[data-mobile-nav-toggle]');
  var closeBtn = overlay.querySelector('[data-mobile-nav-close]');

  var savedScrollY = 0;

  function lockScroll() {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    var scrollY = savedScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function openNav() {
    overlay.showModal();
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');
    lockScroll();
    requestAnimationFrame(function() {
      closeBtn.focus();
    });
  }

  function closeNav() {
    overlay.close();
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');
    unlockScroll();
    resetPanels();
    toggleBtn.focus();
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function() {
      if (overlay.open) {
        closeNav();
      } else {
        openNav();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      closeNav();
    });
  }

  overlay.addEventListener('cancel', function(e) {
    e.preventDefault();
    closeNav();
  });

  /* Panel navigation — single visible panel, animation on entry only */
  function activatePanel(target, direction) {
    var panels = overlay.querySelectorAll('.mobile-nav-overlay__panel');
    panels.forEach(function(p) {
      p.classList.remove('mobile-nav-overlay__panel--active', 'mobile-nav-overlay__panel--from-back');
      p.setAttribute('aria-hidden', 'true');
      p.scrollTop = 0;
    });
    if (direction === 'back') {
      target.classList.add('mobile-nav-overlay__panel--from-back');
    }
    target.classList.add('mobile-nav-overlay__panel--active');
    target.removeAttribute('aria-hidden');
    var navBody = overlay.querySelector('.mobile-nav-overlay__body');
    if (navBody) navBody.scrollTop = 0;
  }

  function resetPanels() {
    var rootPanel = overlay.querySelector('[data-panel-level="0"]');
    if (rootPanel) activatePanel(rootPanel, 'reset');
  }

  function findPanel(level, id) {
    var selector = '.mobile-nav-overlay__panel[data-panel-level="' + level + '"]';
    if (id) selector += '[data-panel-id="' + id + '"]';
    return overlay.querySelector(selector);
  }

  /* Forward navigation */
  overlay.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-panel-target]');
    if (!btn) return;
    e.preventDefault();
    var target = findPanel(parseInt(btn.getAttribute('data-panel-target'), 10), btn.getAttribute('data-panel-id'));
    if (!target) return;
    activatePanel(target, 'forward');
    var backBtn = target.querySelector('.mobile-nav-overlay__back');
    if (backBtn) requestAnimationFrame(function() { backBtn.focus(); });
  });

  /* Back navigation */
  overlay.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-panel-back]');
    if (!btn) return;
    e.preventDefault();
    var target = findPanel(parseInt(btn.getAttribute('data-panel-back'), 10), btn.getAttribute('data-parent-panel'));
    if (!target) return;
    activatePanel(target, 'back');
  });

  /* Language switcher toggle */
  overlay.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-lang-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var options = toggle.parentElement.querySelector('.mobile-nav-overlay__lang-options');
    if (!options) return;

    var isOpen = options.classList.contains('mobile-nav-overlay__lang-options--open');
    if (isOpen) {
      options.classList.remove('mobile-nav-overlay__lang-options--open');
      options.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      options.classList.add('mobile-nav-overlay__lang-options--open');
      options.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });
})();
